"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _router = _interopRequireWildcard(require("@/router"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
const state = {
  uuid: '',
  email: '',
  status: '',
  token: (0, _cookie.getCookie)('ACCESS_TOKEN'),
  refreshToken: (0, _cookie.getCookie)('REFRESH_TOKEN'),
  name: '',
  avatar: '',
  roles: [],
  introduction: '',
  expiryTime: '',
  metadata: {},
  givenName: '',
  familyName: ''
};
const mutations = {
  SET_UUID: (state, uuid) => {
    state.uuid = uuid;
  },
  SET_EMAIL: (state, email) => {
    state.email = email;
  },
  SET_STATUS: (state, status) => {
    state.status = status;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_REFRESH_TOKEN: (state, refreshToken) => {
    state.refreshToken = refreshToken;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar.length > 0 ? avatar : require('@/assets/otr/images/default_avatar.png');
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_EXPIRY_TIME: (state, time) => {
    state.expiryTime = time;
  },
  SET_METADATA: (state, metadata) => {
    state.metadata = metadata;
  },
  SET_GIVEN_NAME: (state, givenName) => {
    state.givenName = givenName;
  },
  SET_FAMILY_NAME: (state, familyName) => {
    state.familyName = familyName;
  }
};
const actions = {
  // user login
  login({
    commit,
    dispatch
  }, userInfo) {
    // const { username, password } = userInfo
    const username = userInfo.username.trim();
    const password = userInfo.password.trim();
    return new Promise((resolve, reject) => {
      (0, _user.login)(username, password).then(response => {
        const data = response.data;

        // console.log('Store-User-login-response', data)

        commit('SET_UUID', data.profile.uuid);
        commit('SET_EMAIL', data.profile.email);
        commit('SET_STATUS', data.profile.status);
        commit('SET_TOKEN', data.accessToken);
        commit('SET_REFRESH_TOKEN', data.refreshToken);
        commit('SET_NAME', data.profile.givenName + ' ' + data.profile.middleName + ' ' + data.profile.familyName);
        commit('SET_AVATAR', data.profile.profilePic);
        // commit('SET_ROLES', data.profile.role)
        commit('SET_INTRODUCTION', data.profile.bio);
        commit('SET_EXPIRY_TIME', (0, _momentTimezone.default)().utc().add(1, 'hours'));
        commit('SET_METADATA', data.profile.metadata || {});
        commit('SET_GIVEN_NAME', data.profile.givenName);
        commit('SET_FAMILY_NAME', data.profile.familyName);
        (0, _log.showDebugLog)('My Roles', data.profile.role);

        // set cookies
        (0, _cookie.setCookie)('ACCESS_TOKEN', data.accessToken);
        (0, _cookie.setCookie)('REFRESH_TOKEN', data.refreshToken);
        (0, _cookie.setCookie)('UUID', data.profile.uuid);
        // setCookie('ROLES', data.profile.role.join('|'))
        (0, _cookie.setCookie)('EMAIL', data.profile.email);
        resolve();
      }).catch(error => {
        reject(error);
        // console.log('Store-User-login-err', error)
      });
    });
  },
  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      // console.log('store-getInfo', token)
      (0, _user.getInfo)(token).then(response => {
        const data = response.data;

        // console.log('store-getInfo-response', data)

        if (!data) {
          reject('Verification failed, please Login again.');
        }
        const {
          role
        } = data;

        // roles must be a non-empty array
        if (!role || role.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_UUID', data.uuid);
        commit('SET_EMAIL', data.email);
        commit('SET_STATUS', data.status);
        commit('SET_NAME', data.givenName + ' ' + (data.middleName ? data.middleName : '') + ' ' + data.familyName);
        commit('SET_AVATAR', data.profilePic);
        commit('SET_INTRODUCTION', data.bio);
        commit('SET_ROLES', data.role);
        commit('SET_METADATA', data.metadata || {});
        commit('SET_GIVEN_NAME', data.givenName);
        commit('SET_FAMILY_NAME', data.familyName);
        resolve(data);
      }).catch(error => {
        reject(error);
        // console.log('store-getInfo-err', error)
      });
    });
  },
  // user logout
  logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      commit('SET_UUID', '');
      commit('SET_EMAIL', '');
      commit('SET_STATUS', '');
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_NAME', '');
      commit('SET_AVATAR', '');
      commit('SET_ROLES', []);
      commit('SET_METADATA', {});
      commit('SET_GIVEN_NAME', '');
      commit('SET_FAMILY_NAME', '');

      // set cookies
      (0, _cookie.removeCookie)('ACCESS_TOKEN');
      (0, _cookie.removeCookie)('REFRESH_TOKEN');
      (0, _cookie.removeCookie)('UUID');
      (0, _cookie.removeCookie)('ROLES');
      (0, _cookie.removeCookie)('EMAIL'); // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      resolve();
    });
  },
  refreshToken({
    commit
  }, rToken) {
    return new Promise((resovle, reject) => {
      // showDebugLog('store-refreshToken-param', rToken)

      (0, _user.refreshCognitoToken)(rToken).then(response => {
        const data = response.data;
        commit('SET_TOKEN', data.accessToken);
        commit('SET_EXPIRY_TIME', (0, _momentTimezone.default)().utc().add(1, 'hours'));
        (0, _cookie.setCookie)('ACCESS_TOKEN', data.accessToken);
        resovle();
      }).catch(error => {
        const msg = typeof error.data === 'undefined' ? error : error.data.message;
        (0, _log.showDebugLog)('store-refreshToken-error', msg);
        // reject('LAP-A0001-2 : ' + 'Unknown error. Please signout and signin again.')
        reject(error);
      });
    });
  },
  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_UUID', '');
      commit('SET_EMAIL', '');
      commit('SET_STATUS', '');
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_NAME', '');
      commit('SET_AVATAR', '');
      commit('SET_ROLES', []);
      commit('SET_METADATA', {});
      commit('SET_GIVEN_NAME', '');
      commit('SET_FAMILY_NAME', '');

      // set cookies
      (0, _cookie.removeCookie)('ACCESS_TOKEN');
      (0, _cookie.removeCookie)('REFRESH_TOKEN');
      (0, _cookie.removeCookie)('UUID');
      (0, _cookie.removeCookie)('ROLES');
      (0, _cookie.removeCookie)('EMAIL');
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles({
    commit,
    dispatch
  }, role) {
    return new Promise(async resolve => {
      const token = role + '-token';
      commit('SET_TOKEN', token);
      (0, _auth.setToken)(token);
      const {
        roles
      } = await dispatch('getInfo');
      (0, _router.resetRouter)();

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, {
        root: true
      });

      // dynamically add accessible routes
      _router.default.addRoutes(accessRoutes);

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      resolve();
    });
  },
  redirectLandingPage({
    commit
  }) {
    return new Promise(resolve => {
      _router.default.push('/dashboard');
      resolve();
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state,
  mutations,
  actions
};